import ActionCableJwt from './ActionCableJwt'
import {WEBSOCKET_API_URL} from '../apiConfig'
import {getAccessToken} from './jwt'

const actionCableJwt = ActionCableJwt.createConnection(async () => getAccessToken())
export const cable = actionCableJwt.createConsumer(WEBSOCKET_API_URL)

export function disconnectWebSocket() {
  cable.subscriptions.consumer.disconnect()
}

export function reconnectWebSocket() {
  cable.subscriptions.consumer.connection.open()
}

export function resetWebSocket() {
  disconnectWebSocket()
  reconnectWebSocket()
}



// WEBPACK FOOTER //
// ./src/utils/api/webSocket.js